// Desc: Returns the current path with the utm parameters
export const pathWithUtm = (path) => {
    return path + window.location.search;
}